<template>
  <div>
    <div>
      <b>Campanha:</b> <span style="font-size: 0.9rem">{{ body.name }}</span>
    </div>
    <div class="mb-2 mt-2">
      <b>Data: </b>
      <span style="font-size: 0.9rem">
        {{ DateTime.fromSQL(body.data).toFormat("dd/MM/yyyy") }}
      </span>
    </div>
    <div>
      <b>Inicia ás:</b> <span style="font-size: 0.9rem">{{ body.hour }} </span>
    </div>
    <br />
    <div style="display: flex; justify-content: space-between; gap: 20px">
      <div style="width: 100%">
        <p style="border-top: 2px solid #dcdcdc; padding-top: 10px">
          Mensagem escolhida
        </p>
        <textarea
          class="inputTextArea form-control"
          rows="6"
          maxlength="500"
          v-model="body.message"
          :disabled="
            body.status === 'Finalizada' || body.status === 'Executando'
          "
        />
      </div>
      <div style="width: 100%">
        <p style="border-top: 2px solid #dcdcdc; padding-top: 10px">
          Destinatários
        </p>
        <div>
          <p
            style="border: 1px solid #dcdcdc; padding: 10px; border-radius: 5px"
          >
            {{ body.contacts.length }} contatos adicionados
          </p>
          <div style="max-height: 200px; overflow: auto; border-radius: 5px">
            <div
              v-for="(item, index) in body.contacts"
              :key="index"
              style="border: 1px solid #dcdcdc; padding: 10px; margin-top: 10px"
            >
              <p style="font-size: 12px; margin: 0px; padding: 0px">
                {{ item.name }} - {{ item.celular }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="col-sm-12 mt-4"
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <button
        class="btn btn-sm"
        style="background-color: #0051a9; color: #fff"
        @click="handleGoBack"
      >
        Voltar
      </button>
      <button
        class="btn btn-sm"
        style="background-color: #0051a9; color: #fff"
        @click="handle"
        v-if="body.status !== 'Finalizada' && body.status !== 'Executando'"
      >
        Finalizar
      </button>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon";
import sweetalert2 from "sweetalert2";
import api from "../../../services/axios";

export default {
  props: {
    nextPage: {
      type: Function,
    },
    body: {
      type: Object,
    },
  },
  data() {
    return {
      DateTime: DateTime,
    };
  },
  methods: {
    async handle() {
      const confirm = await sweetalert2.fire({
        title: "<span style='font-size:14px'>Deseja realmente finalizar a campanha?</span>",
        text: "O envio em massa de mensagens via WhatsApp pode violar os termos de uso da plataforma, acarretando no bloqueio temporário ou permanente do número de origem. Deseja realmente finalizar e iniciar o disparo da campanha?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#0051a9",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, finalizar!",
        cancelButtonText: "Cancelar",
      });

      if (!confirm.isConfirmed) {
        return;
      }

      if (!this.body.id) {
        try {
          await api.post("/campaigns", {
            name: this.body.name,
            description: this.body.message,
            startDate: `${this.body.data} ${this.body.hour}`,
            contacts: this.body.contacts,
          });

          this.$toast.open({
            message: "Campanha criada com sucesso",
            type: "success",
          });

          this.nextPage("listCampanha");
        } catch (error) {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
          });
        }
      }

      if (this.body.id) {
        try {
          await api.put(`/campaigns/${this.body.id}`, {
            name: this.body.name,
            description: this.body.message,
            startDate: `${this.body.data} ${this.body.hour}`,
            contacts: this.body.contacts,
          });

          this.$toast.open({
            message: "Campanha editada com sucesso",
            type: "success",
          });

          this.nextPage("listCampanha");
        } catch (error) {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
          });
        }
      }
    },
    handleGoBack() {
      if (this.body.status === "Finalizada") {
        this.nextPage("listCampanha");
      }

      if (this.body.status === "Executando") {
        this.nextPage("listCampanha");
      }

      if (
        this.body.status !== "Finalizada" &&
        this.body.status !== "Executando"
      ) {
        this.nextPage("newCampanha");
      }
    },
  },
};
</script>

<style scoped>
.swal2-html-container{
  font-size: 10px!important;
}

#swal2-html-container{
  font-size: 10px!important;
}
</style>